import * as Sentry from '@sentry/react';

export interface AuthUser {
  id: string;
  name?: string;
  role?: string;
  clinicId?: string;
  clinicName?: string;
}

const SENTRY_TAGS: Array<keyof Omit<AuthUser, 'id'>> = ['clinicId', 'clinicName', 'role'];

export function identifyUser(user: AuthUser): void {
  Sentry.setUser({ id: user.id });

  for (const tag of SENTRY_TAGS) {
    const value = user[tag];
    if (value !== undefined && value !== null && value !== '') {
      Sentry.setTag(tag, value);
    } else {
      Sentry.setTag(tag, '');
    }
  }
}

export function clearUser(): void {
  Sentry.setUser(null);

  for (const tag of SENTRY_TAGS) {
    Sentry.setTag(tag, '');
  }
}
